import { TeachingGroup } from 'components/models/FormProps';
import { StudentFormResponse } from '../../Page';

export function groupResponsesByTeachingGroupId(
  responses: Array<StudentFormResponse>,
  teachingGroups: Array<TeachingGroup>,
): { [key: number]: Array<StudentFormResponse> } {
  return teachingGroups.reduce((acc, tg) => {
    acc[tg.entity_id] = responses.filter(response => response.teachingGroupIds.some(tgID => tgID === tg.entity_id));

    return acc;
  }, {} as { [key: number]: Array<StudentFormResponse> });
}
